export function BrandMark({ size = 36 }: { size?: number }) {
  return (
    <svg className="brand-mark" width={size} height={size} viewBox="0 0 36 36" aria-hidden="true">
      <defs>
        <linearGradient id="wgrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1f5fe0" />
          <stop offset="100%" stopColor="#4f86f0" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="34" height="34" rx="9" fill="url(#wgrad)" />
      <path
        d="M9.5 12 L13.5 24 L18 16 L22.5 24 L26.5 12"
        stroke="#0b1120" strokeWidth="2.6" fill="none"
        strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  );
}
